export default __webpack_public_path__ + "static/media/shopping-cart.5080b050.svg";